import { ChildAgeDropdown } from "@/components/Inputs/ChildrenAgeSelect/ChildAgeDropdown.tsx";
import { CartAccommodationItem } from "@/stores/EngineStore/interfaces/CartAccommodationItem.ts";
import { memo } from "react";
import { useTranslation } from "react-i18next";

export const ChildrenAgeSelect = memo(
  (props: {
    cartItem: CartAccommodationItem;
    compact?: boolean;
    autoOpen?: boolean;
    instanceId?: string;
  }) => {
    const { t } = useTranslation();

    if (!props.cartItem.children?.length) return null;

    return (
      <div className={`c-age-select${props.compact ? " c-age-select--compact" : ""}`}>
        {props.cartItem.children.map((child, index) => (
          <ChildAgeDropdown
            key={child.id}
            child={child}
            cartItemId={props.cartItem.id}
            compact={props.compact}
            autoOpen={props.autoOpen}
            instanceId={props.instanceId}
            label={props.compact ? `${t("childAge")} ${index + 1}` : undefined}
          />
        ))}
      </div>
    );
  },
);

ChildrenAgeSelect.displayName = "ChildrenAgeSelect";
